import { motion } from "framer-motion";
import { Send, type LucideIcon } from "lucide-react";

interface BottomBarProps {
  primaryLabel: string;
  primaryIcon?: LucideIcon;
  disabled: boolean;
  onPrimary: () => void;
  copyrightText?: string;
}

export function BottomBar({
  primaryLabel,
  primaryIcon,
  disabled,
  onPrimary,
  copyrightText = "©Copyright 2026 NeuCode Talent Academy LLP",
}: BottomBarProps) {
  const Icon = primaryIcon ?? Send;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-[#0a0a1f]/80 backdrop-blur-xl" style={{ height: "72px" }}>
      <div className="mx-auto flex h-full max-w-[1440px] items-center justify-between gap-4 px-6">
        <div className="flex items-center gap-3 text-sm">
          <span className="italic text-white/40">​</span>
          <span className="font-mono text-xs text-white/40">{copyrightText}</span>
        </div>

        <motion.button
          whileHover={!disabled ? { scale: 1.03, y: -1 } : {}}
          whileTap={!disabled ? { scale: 0.97 } : {}}
          type="button"
          onClick={onPrimary}
          disabled={disabled}
          className={`group relative inline-flex items-center gap-2 overflow-hidden rounded-xl px-8 py-3 text-sm font-semibold transition-all duration-200 ${
            disabled
              ? "cursor-not-allowed border border-white/10 bg-white/5 text-white/30"
              : "bg-gradient-to-r from-fuchsia-500 via-violet-500 to-cyan-500 text-white shadow-lg shadow-fuchsia-500/40 hover:shadow-xl hover:shadow-fuchsia-500/50"
          }`}
        >
          {!disabled && (
            <motion.span
              aria-hidden
              className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0"
              animate={{ x: ["-100%", "200%"] }}
              transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
            />
          )}
          <span className="relative">{primaryLabel}</span>
          <Icon className="relative h-4 w-4" />
        </motion.button>
      </div>
    </div>
  );
}